<!-- <h4 class="text-center">modulo catalogo</h4>
<div class="col-lg-12">
  <div class="row">
    <div class="col-lg-3">
      <ul>
        <li>
          <a routerLink="/catalogo" routerLinkActive="active">Productos</a>

        </li>
        <li>
          <a routerLink="/catalogo/categoria" routerLinkActive="active">Categorias</a>
        </li>
      </ul>
    </div>
    <div class="col-lg-9" style="background: rgb(232, 167, 234);">
        <router-outlet></router-outlet>
    </div>
  </div>
</div> -->

<router-outlet></router-outlet>